import { CHANGE_DISTANCE_TOKEN_PARAM } from 'src/modules/changeDistance/constants';
import { changeDistanceService } from 'src/modules/changeDistance/services';

import { encodeQuery, history } from 'utils';

import { clearChangeDistanceRequest, parseUrlParams, readChangeDistanceRequest, writeChangeDistanceRequest } from '../../utils';

import { changeDistanceStore } from '../../stores';

export async function loadChangeDistance() {
  const token = resolveToken();

  if (!token) {
    return;
  }

  changeDistanceStore.setToken(token);

  const result = await changeDistanceService.loadDetails(token);

  if (!result.ok) {
    changeDistanceStore.setError(result.code);

    return;
  }

  changeDistanceStore.setDetails(result.details);
}

function resolveToken(): string | null {
  const { distanceId, changeDistanceToken } = parseUrlParams();

  if (changeDistanceToken) {
    writeChangeDistanceRequest({ token: changeDistanceToken, toDistanceId: distanceId });
    swallowChangeDistanceParams();

    return changeDistanceToken;
  }

  const stored = readChangeDistanceRequest();

  if (!stored) {
    return null;
  }

  if (!distanceId || Number(stored.toDistanceId) !== Number(distanceId)) {
    clearChangeDistanceRequest();

    return null;
  }

  return stored.token;
}

function swallowChangeDistanceParams() {
  const { pathname, search } = history.location;
  const params = encodeQuery.parseQuery(search);

  delete params[CHANGE_DISTANCE_TOKEN_PARAM];

  const query = encodeQuery.stringify(params);

  history.replace(query ? `${pathname}?${query}` : pathname);
}
